const FOOTER_LINKS = {
  热门分类: ['韩漫推荐', '日漫精选', '国漫专区', 'BL漫画', '恋爱漫画', '奇幻漫画', '悬疑漫画', '搞笑漫画'],
  读者服务: ['阅读指南', '更新订阅', '收藏管理', '阅读历史', '夜间模式', '字号调节'],
  关于我们: ['平台介绍', '内容合作', '版权声明', '用户协议', '隐私政策'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">虫虫漫画网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              虫虫漫画网是领先的<strong className="text-background-200">免费漫画</strong>在线阅读平台，提供海量<strong className="text-background-200">韩漫</strong>、<strong className="text-background-200">日漫</strong>、<strong className="text-background-200">国漫</strong>资源，支持全集漫画下拉式阅读，每日更新热门连载，让漫画爱好者畅享阅读乐趣。
            </p>
          </div>

          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#hero"
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</a>
              <a href="#about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">关于我们</a>
              <a href="#contact" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">联系我们</a>
            </div>
            <div className="text-sm text-background-500">
              合作伙伴区域 — 更多精彩内容即将上线
            </div>
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 虫虫漫画网 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}